import React, { Component } from 'react';
import api from '../../api/';
import ParadigmaTable from "../../components/ParadigmaTable/"
import functions from '../../functions/';
import 'react-datetime/css/react-datetime.css';
import dateFunctions from '../functions/dateFunctions';
import DateFilter from '../../components/ParadigmaTable/DateFilter';
import VisibilizarProdModal from './VisibilizarProdModal';
import EditDiaVisibilidad from './EditDiaVisibilidad';
import moment from 'moment';

class GestionProductividad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null,
            filter: [],
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "personal_id",
                    id: "personal_id",
                    accessor: "personal_id",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Lider técnico",
                    id: "lider",
                    accessor: "lider",
                    width: 200,
                    show: true,
                    private: false,
                    filterable: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha_imputacion",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDate(d.fecha_imputacion),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "name",
                    accessor: d => d.name,
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa",
                    width: 200,
                    accessor: d => d.empresa,
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Importe ($)",
                    id: "importe",
                    width: 150,
                    accessor: d => functions.formatCurrency(d.importe),
                    show: true,
                    filterable: false,
                    className: "text-right",
                },
                {
                    Header: "Fecha Visualización",
                    id: "fecha_visualizacion",
                    accesor: d => d.fecha_visualizacion,
                    show: false,
                },
                { 
                    Header: "Visibilidad",
                    id: "visibilidad",
                    accessor: d => {
                        if (d.visibilidad==="Visible"){
                                return <div className="ui-badge ui-badge-info">
                                    {"Visible"}
                                </div>;
                        }else {
                                return <div className="ui-badge ui-badge-warning">
                                     {`No visible hasta el ${moment(d.fecha_visualizacion).format('DD-MM-YYYY')}`}
                                </div>
                        }
                    },
                    show: true,
                    width: 125,
                    filterable: true,
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            className="form-control"
                            value={filter ? filter.value : "TODOS"}
                        >
                            <option value="">Todos</option>
                            <option value="Visible">Visible</option>
                            <option value="No Visible">No Visible</option>
                        </select>
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
            buttons={[
                {
                    edit: true,
                    // permission: 'imputaciones_imputaciones_edit',
                    component: (props) => <VisibilizarProdModal {...props} />,
                },
                {
                    edit: true,
                    // permission: 'imputaciones_imputaciones_edit',
                    component: (props) => <EditDiaVisibilidad {...props} />,
                },
                ]}
                outerFilter={this.state.filter}
                apiUrl={api.proyectos.cargadatos.productividad.gestionList}
                columns={this.state.columns}
                title={"Gestión Productividad"}
            />
        );
    }
}

export default GestionProductividad;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/GestionProductividad.js